// Drop Down List Values
export const professionalAreasOptions = [
  { value: "informationTechnology" },
  { value: "healthcare" },
  { value: "engineering" },
  { value: "education" },
  { value: "finance" },
  { value: "marketing" },
  { value: "sales" },
  { value: "humanResources" },
  { value: "construction" },
  { value: "legal" },
  { value: "manufacturing" },
  { value: "customerService" },
  { value: "hospitality" },
  { value: "transportation" },
  { value: "realEstate" },
  { value: "artsAndEntertainment" },
  { value: "publicRelations" },
  { value: "retail" },
  { value: "researchAndDevelopment" },
  { value: "government" },
  { value: "nonprofit" },
  { value: "telecommunications" },
  { value: "agriculture" },
  { value: "environmentalServices" },
  { value: "mediaAndCommunications" },
  { value: "insurance" },
  { value: "energy" },
  { value: "aerospace" },
  { value: "pharmaceuticals" },
  { value: "other" },
];

export const reasonOptions = [{ value: "looking" }, { value: "offering" }];
